import api from "@/lib/api";

export default {
    urlGetAll: "/api/v1/finance/chart-of-accounts/get-all",
    urlCreate: "/api/v1/finance/chart-of-accounts/create",
    urlUpdate: "/api/v1/finance/chart-of-accounts/update",
    urlDelete: "/api/v1/finance/chart-of-accounts/delete",

    async getAll(params = {}) {
        const response = await api.get(this.urlGetAll, { params });
        return response.data;
    },
    async create(model) {
        const response = await api.post(this.urlCreate, model);
        return response.data;
    },
    async update(model) {
        const response = await api.put(this.urlUpdate, model);
        return response.data;
    },
    async delete(ids) {
        const response = await api.delete(`${this.urlDelete}?ids=${ids.join(",")}`);
        return response.data;
    },
};
